import { ReportResult } from '../../../models';

export const updateReportResultItem = (
  reportResults: ReportResult[],
  updatedItem: ReportResult,
): ReportResult[] => {
  return reportResults.map((item) => {
    if (item.taskId !== updatedItem.taskId) return item;
    return { ...item, ...updatedItem };
  });
};
